import { render, staticRenderFns } from "./DinnerUsageRate.vue?vue&type=template&id=663db040&scoped=true&"
import script from "./DinnerUsageRate.vue?vue&type=script&lang=js&"
export * from "./DinnerUsageRate.vue?vue&type=script&lang=js&"
import style0 from "./DinnerUsageRate.vue?vue&type=style&index=0&id=663db040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663db040",
  null
  
)

export default component.exports